<template>
  <div class="d-flex align-center flex-column">
    <v-card>
      <!-- Toolbar superior -->
      <s-toolbar
        label="Requerimiento de Personal - Formato PDF"
        dark
        :color="'#04abc5'"
        close
        @close="$emit('close')"
        class="mb-4"
      />

      <v-card-title style="font-size: small">
        <v-row>
          <v-col align="right">
            <!-- Impresión rápida directa -->
            <v-btn
              fab
              style="margin-right: 10px"
              x-small
              color="success"
              @click="printDirectly()"
              title="Imprimir directamente"
            >
              <v-icon medium>mdi-printer-check</v-icon>
            </v-btn>
            <!-- Descargar/Imprimir PDF -->
            <!-- <v-btn
              fab
              style="margin-right: 10px"
              x-small
              color="warning"
              @click="downloadPdf(1)"
              title="Descargar PDF"
            >
              <v-icon medium>mdi-file-pdf-box</v-icon>
            </v-btn> -->
          </v-col>
        </v-row>
      </v-card-title>

      <!-- Generador de PDF -->
      <vue-html2pdf
        :show-layout="true"
        :float-layout="false"
        :enable-download="false"
        :preview-modal="false"
        :filename="pdfFileName"
        :paginate-elements-by-height="60"
        :pdf-quality="2"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="725px"
        :manual-pagination="true"
        :margin="0.0"
        :htmlToPdfOptions="htmlToPdfOptions"
        @beforeDownload="beforeDownload($event)"
        @progress="onProgress($event)"
        ref="html2Pdf"
      >
        <section slot="pdf-content" style="margin: 0">
          <div class="formato-container">
            <div class="formato-requerimiento">
              <div class="page">
                <!-- ENCABEZADO -->
                <table class="header-table">
                  <tr>
                    <td
                      style="
                        width: 25%;
                        vertical-align: middle;
                        text-align: left;
                        border: none;
                        padding: 10px;
                      "
                    >
                      <img
                        src="/static/logo_sp.png"
                        alt="Logo Sunshine"
                        style="width: 120px; height: auto"
                      />
                    </td>
                    <td
                      style="
                        width: 45%;
                        text-align: center;
                        vertical-align: middle;
                        border: none;
                      "
                    >
                      <div class="title">REQUERIMIENTO DE PERSONAL</div>
                      <!-- <div style="font-size: 9pt; margin-top: 4px;">Formato de Solicitud de Personal</div> -->
                    </td>
                    <td
                      style="
                        width: 30%;
                        text-align: left;
                        vertical-align: middle;
                        border: none;
                        padding: 8px;
                        font-size: 8pt;
                      "
                    >
                      <document-header-control
                        param-name="PdfHmnStaffingRequirement"
                        :default-data="defaultHeaderData"
                      />
                      <div style="font-size: 8pt">
                        <strong>PÁGINAS:</strong> 01 de 01
                      </div>
                    </td>
                  </tr>
                </table>

                <!-- INFORMACIÓN DEL REQUERIMIENTO -->
                <v-divider style="margin: 8px 0"></v-divider>

                <table class="data-table">
                  <tr>
                    <td
                      colspan="4"
                      style="
                        background-color: #333;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      <strong>INFORMACIÓN DEL REQUERIMIENTO</strong>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 25%; font-weight: bold">
                      <strong>Fecha de Tramite</strong>
                    </td>
                    <td style="width: 25%">
                      {{ $fun.formatDateView(requirement.SecCreate) }}
                    </td>
                    <td style="width: 25%; font-weight: bold">
                      <strong>Nº de Personal Requerido:</strong>
                    </td>
                    <td style="width: 25%">{{ requirement.ReqQuantity }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold">
                      <strong>Área:</strong>
                    </td>
                    <td>{{ requirement.AreName }}</td>
                    <td style="font-weight: bold">
                      <strong>Centro de Costo:</strong>
                    </td>
                    <td>{{ requirement.CceName }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold">
                      <strong>Puesto:</strong>
                    </td>
                    <td colspan="3">{{ requirement.PstName }}</td>
                    <!-- <td style="font-weight: bold">
                      <strong>Linea de negocio:</strong>
                    </td>
                    <td>{{ requirement.BslName }}</td> -->
                  </tr>
                  <tr>
                    <td style="font-weight: bold">
                      <strong>Motivo de Requerimiento:</strong>
                    </td>
                    <td>
                      {{ requirement.TypeMotiveRequirementName }}
                    </td>
                    <td style="font-weight: bold">
                      <strong>Tipo de Cobertura:</strong>
                    </td>
                    <td>
                      {{ requirement.TypeSeekingName }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold">
                      <strong>Vigencia de Contrato:</strong>
                    </td>
                    <td colspan="3">
                      {{ $fun.formatDateView(requirement.ReqEndContract) }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold">
                      <strong>Jefe Inmediato:</strong>
                    </td>
                    <td colspan="3">{{ resolvedPstParentName }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold; vertical-align: top">
                      <strong>Consideraciones del Perfil:</strong>
                    </td>
                    <td colspan="3">
                      <div v-html="formatPositionProfile(profileData)"></div>
                    </td>
                  </tr>
                  <tr v-if="requirement.ReqObservation">
                    <td style="font-weight: bold">
                      <strong>Comentarios / Observaciones:</strong>
                    </td>
                    <td colspan="3">{{ requirement.ReqObservation }}</td>
                  </tr>
                  <tr v-show="$fun.isAdmin()">
                    <td
                      colspan="4"
                      style="
                        background-color: #333;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      <strong>INFORMACIÓN POR RRHH</strong>
                    </td>
                  </tr>
                  <tr v-show="$fun.isAdmin()">
                    <td style="font-weight: bold">
                      <strong>Remuneración Básica:</strong>
                    </td>
                    <td colspan="3">
                      <tr>
                        <!-- quitarle los bordes -->
                        <td
                          style="
                            font-weight: bold;
                            border: none;
                            padding: 0;
                            margin: 0;
                          "
                        >
                          <strong v-if="requirement.ReqPaymentType === 1"
                            >Fijo:</strong
                          >
                          <strong v-if="requirement.ReqPaymentType === 2"
                            >Rango Salarial:</strong
                          >
                          <strong v-if="requirement.ReqPaymentType === 3"
                            >Escala:</strong
                          >
                        </td>
                        <td style="border: none; padding: 0; margin: 0">
                          <tr
                            v-if="requirement.ReqPaymentType === 1"
                            style="border: none; padding: 0; margin: 0"
                          >
                            {{
                              formatCurrency(
                                getBudgetDisplayValue(requirement.ReqPayValue1),
                              )
                            }}
                          </tr>
                          <tr
                            v-if="requirement.ReqPaymentType === 2"
                            style="border: none; padding: 0; margin: 0"
                          >
                            {{
                              formatCurrency(
                                getBudgetDisplayValue(requirement.ReqPayValue1),
                              )
                            }}
                            -
                            {{
                              formatCurrency(
                                getBudgetDisplayValue(requirement.ReqPayValue2),
                              )
                            }}
                          </tr>
                          <tr
                            v-if="requirement.ReqPaymentType === 3"
                            style="border: none; padding: 0; margin: 0"
                          >
                            <td
                              v-for="(
                                level, index
                              ) in profileData?.TechnicalLevels || []"
                              :key="index"
                              style="padding-right: 12px"
                            >
                              <strong>{{ level }}:</strong>
                              <div>
                                {{
                                  formatCurrency(
                                    getBudgetDisplayValue(
                                      requirement[`ReqPayValue${index + 1}`],
                                    ),
                                  )
                                }}
                              </div>
                            </td>
                          </tr>
                        </td>
                      </tr>
                    </td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold">
                      <strong>Régimen Laboral:</strong>
                    </td>
                    <td colspan="3">{{ resolvedTypeLaborRegimeName }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold">
                      <strong>Tipo de Planilla:</strong>
                    </td>
                    <td colspan="3">{{ resolvedTypePayrollName }}</td>
                  </tr>
                  <tr v-if="approvalComments.length">
                    <td
                      colspan="4"
                      style="
                        background-color: #333;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      <strong>COMENTARIOS DE APROBADORES</strong>
                    </td>
                  </tr>
                  <tr
                    v-for="item in approvalComments"
                    :key="`comment-${item.RapID}`"
                  >
                    <td>{{ item.PrsName || "-" }}</td>
                    <td colspan="3">{{ item.RapObservation }}</td>
                  </tr>
                </table>

                <!-- FIRMAS Y SELLOS -->
                <div style="margin-top: 20px" v-if="approvalList && approvalList.length">
                  <p
                    style="
                      font-weight: bold;
                      text-align: center;
                      font-size: 10px;
                      margin-bottom: 12px;
                      text-transform: uppercase;
                    "
                  >
                    FIRMAS DE APROBACIÓN
                  </p>

                  <table style="width: 100%; border-collapse: collapse">
                    <tr
                      v-for="(row, rowIndex) in approvedListChunked"
                      :key="`row-${rowIndex}`"
                    >
                      <td
                        v-for="(approval, index) in row"
                        :key="index"
                        style="
                          text-align: center;
                          vertical-align: top;
                          padding: 4px;
                          width: 33.33%;
                        "
                      >
                        <!-- APROBADO / FIRMADO -->
                        <div
                          v-if="approval.RapStatus === 4"
                          style="
                            border: 1px dashed #333;
                            background-color: #fcfcfc;
                            border-radius: 4px;
                            padding: 8px 6px;
                            text-align: center;
                            height: 75px;
                            box-sizing: border-box;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            align-items: center;
                          "
                        >
                          <div>
                            <div
                              style="
                                font-size: 7.5pt;
                                color: #444;
                                margin-bottom: 2px;
                                line-height: 1.1;
                              "
                            >
                              Aprobado por: <strong>{{ approval.PrsName || 'Aprobador' }}</strong>
                            </div>
                            <div
                              v-if="approval.PstName"
                              style="
                                font-size: 7pt;
                                color: #666;
                                line-height: 1.1;
                              "
                            >
                              {{ approval.PstName }}
                            </div>
                          </div>
                          <div
                            v-if="approval.RapApprovalDT"
                            style="
                              font-size: 7pt;
                              color: #222;
                              font-weight: 500;
                              line-height: 1.1;
                              margin-top: 2px;
                            "
                          >
                            el {{ $fun.formatDateTimeView(approval.RapApprovalDT) }}
                          </div>
                        </div>

                        <!-- RECHAZADO -->
                        <div
                          v-else-if="approval.RapStatus === 3"
                          style="
                            border: 1px dashed #e11d48;
                            background-color: #fff1f2;
                            border-radius: 4px;
                            padding: 8px 6px;
                            text-align: center;
                            height: 75px;
                            box-sizing: border-box;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            align-items: center;
                          "
                        >
                          <div>
                            <div
                              style="
                                font-size: 7.5pt;
                                color: #e11d48;
                                margin-bottom: 2px;
                                line-height: 1.1;
                                font-weight: bold;
                              "
                            >
                              Rechazado por: {{ approval.PrsName || 'Aprobador' }}
                            </div>
                            <div
                              v-if="approval.PstName"
                              style="
                                font-size: 7pt;
                                color: #9f1239;
                                line-height: 1.1;
                              "
                            >
                              {{ approval.PstName }}
                            </div>
                          </div>
                          <div
                            v-if="approval.RapApprovalDT"
                            style="
                              font-size: 7pt;
                              color: #881337;
                              font-weight: 500;
                              line-height: 1.1;
                              margin-top: 2px;
                            "
                          >
                            el {{ $fun.formatDateTimeView(approval.RapApprovalDT) }}
                          </div>
                        </div>

                        <!-- PENDIENTE DE FIRMA -->
                        <div
                          v-else
                          style="
                            border: 1px dashed #cbd5e1;
                            background-color: #f8fafc;
                            border-radius: 4px;
                            padding: 8px 6px;
                            text-align: center;
                            height: 75px;
                            box-sizing: border-box;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            align-items: center;
                          "
                        >
                          <div>
                            <div
                              style="
                                font-size: 7.5pt;
                                color: #d97706;
                                font-weight: bold;
                                margin-bottom: 2px;
                                line-height: 1.1;
                              "
                            >
                              PENDIENTE
                            </div>
                            <div
                              v-if="approval.PrsName"
                              style="
                                font-size: 7pt;
                                color: #334155;
                                font-weight: 600;
                                line-height: 1.1;
                              "
                            >
                              {{ approval.PrsName }}
                            </div>
                            <div
                              v-if="approval.PstName"
                              style="
                                font-size: 7pt;
                                color: #64748b;
                                line-height: 1.1;
                              "
                            >
                              {{ approval.PstName }}
                            </div>
                          </div>
                          <div
                            style="
                              font-size: 6.5pt;
                              color: #94a3b8;
                              font-style: italic;
                              line-height: 1.1;
                              margin-top: 2px;
                            "
                          >
                            Pendiente de firma
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>

                <!-- PIE DE PÁGINA -->
                <div
                  style="
                    margin-top: 20px;
                    text-align: center;
                    font-size: 7pt;
                    color: #999;
                    border-top: 1px solid #ddd;
                    padding-top: 8px;
                  "
                >
                  <p>
                    Documento generado automáticamente el {{ currentDateTime }}
                  </p>
                  <p>
                    Este documento es de carácter confidencial y está reservado
                    solo para uso interno
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </vue-html2pdf>
    </v-card>

    <!-- Overlay de progreso -->
    <v-overlay :value="uploading" opacity="0.3">
      <v-card class="pa-4" outlined>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        <p class="mt-3">Generando PDF... {{ progress }}%</p>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import DocumentHeaderControl from "@/components/Utils/DocumentHeaderControl.vue";
import _sStaffingRequirement from "@/services/HumanResource/RecruitmentSelection/HmnStaffingRequirement.js";
import _sApproval from "@/services/HumanResource/RecruitmentSelection/HmnRequirementApprovalService.js";
import _sGenPositionProfile from "@/services/General/GenPositionProfileService.js";
import _sDefinition from "@/services/General/DefinitionService.js";

export default {
  name: "PdfHmnStaffingRequirement",
  components: {
    VueHtml2pdf,
    DocumentHeaderControl,
  },
  props: {
    reqId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      requirement: {},
      profileData: null,
      approvalList: [],
      activeCompetitionLevels: [],
      approverSignatures: {}, // { 'NOMBRE': base64 } - mismo patrón que PdfClinicalHistory
      uploading: false,
      progress: 0,
      defaultHeaderData: {
        codigo: "SIG-ES-RH-FR-001",
        version: "04",
        fechaCreacion: "",
        ultimaRevision: "",
      },
      htmlToPdfOptions: {
        margin: 0,
        filename: "Requerimiento_Personal.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { orientation: "portrait", unit: "mm", format: "a4" },
      },
    };
  },
  computed: {
    pdfFileName() {
      const doc = this.requirement?.ReqID || "Requerimiento";
      return `Requerimiento_${doc}.pdf`;
    },
    currentDate() {
      return new Date().toLocaleDateString("es-SV");
    },
    currentDateTime() {
      return new Date().toLocaleString("es-SV");
    },
    approvedListChunked() {
      // Dividir todo el array de aprobaciones en grupos de 3 para mostrar máximo 3 por fila
      const list = this.approvalList || [];
      const chunks = [];
      for (let i = 0; i < list.length; i += 3) {
        chunks.push(list.slice(i, i + 3));
      }
      return chunks;
    },
    approvalComments() {
      return (this.approvalList || []).filter(
        (a) => String(a?.RapObservation || "").trim().length > 0,
      );
    },
    snapshotData() {
      return this.parseSnapshotData(this.requirement?.ReqSnapshotJSON);
    },
    resolvedTypePayrollName() {
      return (
        this.snapshotData?.TypePayrollName ||
        this.requirement?.TypePayrollName ||
        "-"
      );
    },
    resolvedTypeLaborRegimeName() {
      return (
        this.snapshotData?.TypeLaborRegimeName ||
        this.requirement?.TypeLaborRegimeName ||
        "-"
      );
    },
    resolvedPstParentName() {
      return (
        this.snapshotData?.PstParentName ||
        this.requirement?.PstParentName ||
        "-"
      );
    },
  },
  methods: {
    parseSnapshotData(raw) {
      const text = String(raw || "").trim();
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch (_) {
        return null;
      }
    },
    async loadActiveCompetitionLevels() {
      try {
        const response = await _sDefinition.definitiongroup(
          1083,
          0,
          this.$fun.getUserID(),
        );
        const items = Array.isArray(response?.data) ? response.data : [];
        this.activeCompetitionLevels = items
          .filter(
            (x) =>
              Number(x?.SecStatus) === 1 ||
              x?.SecStatus === undefined ||
              x?.SecStatus === null,
          )
          .map((x) => String(x?.DedValue ?? "").trim())
          .filter((x) => !!x)
          .sort((a, b) => Number(a) - Number(b));
      } catch (_) {
        this.activeCompetitionLevels = [];
      }
    },
    getCompetitionLevelsFromSnapshot(snapshot) {
      const items = Array.isArray(snapshot?.CompetitionLevels)
        ? snapshot.CompetitionLevels
        : [];

      return items
        .map((x) => String(x?.DedValue ?? x?.value ?? "").trim())
        .filter((x) => !!x)
        .sort((a, b) => Number(a) - Number(b));
    },
    buildProfileDataFromSnapshotRows(rows) {
      const list = Array.isArray(rows) ? rows : [];
      const minMaxMap = {};
      const normalizeText = (value) =>
        String(value || "")
          .trim()
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

      list
        .filter((r) => Number(r.GroupID) === 1084)
        .forEach((row) => {
          const key =
            String(row.TypeProfileText || "").trim() || "Sin especificar";
          if (!minMaxMap[key]) {
            minMaxMap[key] = { TypeProfileText: key, Min: "", Max: "" };
          }
          const mm = normalizeText(row.PprMinMaxDescription);
          if (mm.includes("mín") || mm.includes("min"))
            minMaxMap[key].Min = row.PprDescription || "";
          if (mm.includes("máx") || mm.includes("max"))
            minMaxMap[key].Max = row.PprDescription || "";
        });

      const resolveLevelLabel = (row, groupID) => {
        const descRaw = String(row?.PprQualificationDescription || "").trim();
        const desc = normalizeText(descRaw);
        const value = Number(row?.PprQualificationValue);

        if (descRaw) return descRaw;

        if (!Number.isNaN(value) && value > 0) {
          if (groupID === 1085 && value <= 3) {
            if (value === 1) return "Básico";
            if (value === 2) return "Intermedio";
            if (value === 3) return "Avanzado";
          }
          return String(value);
        }

        return "N/A";
      };

      const sortLevels = (levels) => {
        return Array.from(levels).sort((a, b) => {
          const an = Number(a);
          const bn = Number(b);
          if (!Number.isNaN(an) && !Number.isNaN(bn)) return an - bn;
          return String(a).localeCompare(String(b), "es");
        });
      };

      const technicalDynamic = list
        .filter((r) => Number(r.GroupID) === 1085)
        .map((row) => ({
          TypeProfileText: row.TypeProfileText,
          PprDescription: row.PprDescription,
          LevelLabel: resolveLevelLabel(row, 1085),
        }));

      const competenciesDynamic = list
        .filter((r) => Number(r.GroupID) === 1086)
        .map((row) => ({
          TypeProfileText: row.TypeProfileText,
          PprDescription: row.PprDescription,
          NumericLevel: Number(
            String(row.PprQualificationDescription || "").trim(),
          ),
          LevelLabel: resolveLevelLabel(row, 1086),
        }));

      const technicalLevelsDefault = ["Básico", "Intermedio", "Avanzado"];
      const technicalLevelsFound = new Set(
        technicalDynamic
          .map((x) => String(x.LevelLabel || "").trim())
          .filter((x) => !!x && x !== "N/A"),
      );
      const technicalLevels = [
        ...technicalLevelsDefault.filter((x) => technicalLevelsFound.has(x)),
        ...sortLevels(
          Array.from(technicalLevelsFound).filter(
            (x) => !technicalLevelsDefault.includes(x),
          ),
        ),
      ];

      const competencyLevels = Array.from(
        new Set(
          competenciesDynamic
            .map((x) => x.NumericLevel)
            .filter((x) => !Number.isNaN(x) && x > 0),
        ),
      )
        .sort((a, b) => a - b)
        .map((x) => String(x));

      const resolvedCompetencyLevels =
        this.activeCompetitionLevels.length > 0
          ? this.activeCompetitionLevels
          : competencyLevels;

      const experience = list
        .filter((r) => Number(r.GroupID) === 1087)
        .map((row) => ({
          PprDescription: row.PprDescription,
          TimeDescription: `${String(
            row.PprQualificationDescription || "",
          ).trim()} AÑO(S)`,
        }));

      return {
        MinMax: Object.values(minMaxMap),
        TechnicalSkills: technicalDynamic,
        Tools: competenciesDynamic,
        TechnicalLevels: technicalLevels,
        CompetencyLevels: resolvedCompetencyLevels,
        Experience: experience,
      };
    },
    loadRequirement() {
      _sStaffingRequirement
        .byID(this.reqId, this.$fun.getUserID())
        .then(async (r) => {
          if (r.data) {
            this.requirement = r.data;
            const snapshot = this.parseSnapshotData(r.data.ReqSnapshotJSON);
            const snapshotCompetitionLevels =
              this.getCompetitionLevelsFromSnapshot(snapshot);
            if (snapshotCompetitionLevels.length > 0) {
              this.activeCompetitionLevels = snapshotCompetitionLevels;
            } else {
              await this.loadActiveCompetitionLevels();
            }
            console.log("Parsed snapshot data:", snapshot);

            const snapshotRows = snapshot?.ProfileRows;
            if (Array.isArray(snapshotRows) && snapshotRows.length > 0) {
              this.profileData =
                this.buildProfileDataFromSnapshotRows(snapshotRows);
            } else {
              this.loadProfileData(r.data.ReqPstID);
            }
          }
        })
        .catch(() => {
          this.$fun.alert("Error al cargar el requerimiento", "error");
        });
    },
    loadProfileData(pstId) {
      if (!pstId) {
        this.profileData = null;
        return;
      }

      _sGenPositionProfile
        .getPositionProfileAll(pstId, this.$fun.getUserID())
        .then((r) => {
          this.profileData = r.data || null;
        })
        .catch(() => {
          this.profileData = null;
        });
    },
    loadApprovals() {
      _sApproval
        .byReqID(this.reqId, this.$fun.getUserID())
        .then((r) => {
          console.log("PdfHmnStaffingRequirement - Approvals loaded:", r.data);

          this.approvalList = r.data || [];
          // Cargar las firmas de los aprobadores
          this.loadSignatures();
        })
        .catch(() => {
          this.approvalList = [];
        });
    },
    async loadSignatures() {
      // Cargar las firmas de cada aprobador aprobado
      this.approverSignatures = {};

      // Filtrar solo por RapStatus = 4 (no depender de RapApprovalDT)
      const approvedApprovals = (this.approvalList || []).filter(
        (a) => a.RapStatus === 4,
      );
      console.log("Approved approvals after filter:", approvedApprovals);

    },
    printDirectly() {
      this.$emit("printed", { reqId: this.reqId, source: "printDirectly" });

      // Imprimir directamente el contenido del formato de requerimiento
      const printContent = this.$el.querySelector(".formato-container");
      if (!printContent) {
        console.error("No se encontró el contenido a imprimir");
        return;
      }

      const printableClone = printContent.cloneNode(true);

      const printWindow = window.open("", "", "height=800,width=1200");
      printWindow.document.write(
        "<html><head><title>Requerimiento de Personal</title>",
      );
      printWindow.document.write(`
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { font-family: Arial, sans-serif; }
          .formato-container { background-color: #fff; padding: 8px; }
          .formato-requerimiento { font-family: Arial, sans-serif; font-size: 9pt; }
          .page { padding: 12px; margin-bottom: 10px; background: white; page-break-after: always; }
          .page:last-child { page-break-after: auto; }
          .header-table, .data-table { width: 100%; border-collapse: collapse; margin-top: 2px; }
          .header-table td, .data-table td { border: 1px solid black; padding: 6px; vertical-align: top; font-size: 9pt; }
          .title { font-size: 12pt; font-weight: bold; text-align: center; margin: 2px 0; line-height: 1.2; }
          img { max-width: 100%; height: auto; }
          @media print {
            .formato-container { background-color: #fff; padding: 0; }
            .page { border: none; box-shadow: none; margin: 0; padding: 10px; width: 100%; page-break-after: always; }
            .page:last-child { page-break-after: auto; }
          }
        </style>
      `);
      printWindow.document.write("</head><body>");
      printWindow.document.write(printableClone.innerHTML);
      printWindow.document.write("</body></html>");
      printWindow.document.close();

      // Esperar a que se cargue el contenido antes de imprimir
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 500);
    },
    downloadPdf(mode) {
      this.uploading = true;
      this.progress = 0;
      this.$nextTick(() => {
        this.$refs.html2Pdf.generatePdf();
      });
    },
    onProgress(p) {
      this.progress = p;
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      // Permitir descarga y luego limpiar el estado
      setTimeout(() => {
        this.uploading = false;
        this.progress = 0;
      }, 1000);
      return true;
    },
    formatCurrency(value) {
      if (value === null || value === undefined || value === "" || Number.isNaN(Number(value))) {
        return "PEN 0.00";
      }
      return new Intl.NumberFormat("es-SV", {
        style: "currency",
        currency: "PEN",
      }).format(Number(value));
    },
    getBudgetDisplayValue(value) {
      if (value === null || value === undefined || value === "") return null;
      const numericValue = Number(value);
      if (!Number.isNaN(numericValue) && String(value).trim() !== "") {
        return numericValue;
      }
      try {
        const decrypted = this.$fun.decrypt(value);
        const parsed = Number(decrypted);
        return Number.isNaN(parsed) ? null : parsed;
      } catch {
        return null;
      }
    },
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      return d.toLocaleDateString("es-SV");
    },
    formatDateTime(date) {
      if (!date) return "-";
      const d = new Date(date);
      const dateStr = d.toLocaleDateString("es-SV");
      const timeStr = d.toLocaleTimeString("es-SV", {
        hour: "2-digit",
        minute: "2-digit",
      });
      return `${dateStr} ${timeStr}`;
    },
    formatPositionProfile(profileData) {
      // Retorna un HTML formateado con los datos del perfil ocupacional
      // Validaciones iniciales
      if (!profileData) return "";

      const hasMinMax = profileData.MinMax && profileData.MinMax.length > 0;
      const hasTechnical =
        profileData.TechnicalSkills && profileData.TechnicalSkills.length > 0;
      const hasTools = profileData.Tools && profileData.Tools.length > 0;
      const hasExperience =
        profileData.Experience && profileData.Experience.length > 0;

      if (!hasMinMax && !hasTechnical && !hasTools && !hasExperience) {
        return "";
      }

      let html =
        '<div style="margin-top: 12px; padding: 10px; background-color: #f5f5f5; border-radius: 4px;">';

      // Sección: Formación Académica (tabla)
      if (hasMinMax) {
        html += `
  <div>
    <strong style="font-size:10pt;">Formación Académica</strong>

    <table style="
        width:100%;
        border-collapse:collapse;
        margin-top:6px;
        font-size:9pt;
        background:#fff;
    ">
      <thead>
        <tr style="background:#e6e6e6;">
          <th style="border:1px solid #999;padding:4px;text-align:left;">Tipo</th>
          <th style="border:1px solid #999;padding:4px;text-align:left;">Mínimo</th>
          <th style="border:1px solid #999;padding:4px;text-align:left;">Máximo</th>
        </tr>
      </thead>
      <tbody>
  `;

        profileData.MinMax.forEach((item) => {
          const typeText =
            (item.TypeProfileText || "").trim() || "Sin especificar";
          const minText = (item.Min || "").toString().trim();
          const maxText = (item.Max || "").toString().trim();

          html += `
      <tr>
        <td style="border:1px solid #999;padding:4px;font-weight:600;">
          ${typeText}
        </td>
        <td style="border:1px solid #999;padding:4px;">
          ${minText || "-"}
        </td>
        <td style="border:1px solid #999;padding:4px;">
          ${maxText || "-"}
        </td>
      </tr>
    `;
        });

        html += `
      </tbody>
    </table>
  </div>
  `;
      }

      // Sección: Conocimientos Complementarios
      if (hasTechnical) {
        const dynamicTechnicalLevels = Array.isArray(
          profileData.TechnicalLevels,
        )
          ? profileData.TechnicalLevels
          : [];

        if (dynamicTechnicalLevels.length > 0) {
          html += `
  <div>
    <strong style="font-size:10pt;">Conocimientos Complementarios</strong>

    <table style="width:100%;border-collapse:collapse;font-size:9pt;background:#fff;">
      <thead>
        <tr style="background:#e6e6e6;">
          <th style="border:1px solid #999;padding:4px;width:25%;">Tipo</th>
          <th style="border:1px solid #999;padding:4px;">Descripción</th>
  `;

          dynamicTechnicalLevels.forEach((level) => {
            html += `<th style="border:1px solid #999;padding:4px;width:80px;text-align:center;">${level}</th>`;
          });

          html += `
        </tr>
      </thead>
      <tbody>
  `;

          const grouped = {};
          profileData.TechnicalSkills.forEach((skill) => {
            const type = (skill.TypeProfileText || "OTROS").trim();
            if (!grouped[type]) grouped[type] = [];
            grouped[type].push(skill);
          });

          Object.keys(grouped).forEach((type) => {
            const skills = grouped[type];
            const rowspan = skills.length;

            skills.forEach((skill, index) => {
              const desc = (skill.PprDescription || "").trim();
              html += `<tr>`;

              if (index === 0) {
                html += `
          <td rowspan="${rowspan}" style="border:1px solid #999;padding:4px;font-weight:600;vertical-align:middle;">
            ${type}
          </td>
        `;
              }

              html += `<td style="border:1px solid #999;padding:4px;">${desc}</td>`;

              dynamicTechnicalLevels.forEach((level) => {
                const mark = skill.LevelLabel === level ? "P" : "";
                html += `<td style="border:1px solid #999;text-align:center;">${mark}</td>`;
              });

              html += `</tr>`;
            });
          });

          html += `
      </tbody>
    </table>
  </div>
  `;
        } else {
          html += `
  <div>
    <strong style="font-size:10pt;">Conocimientos Complementarios</strong>

    <table style="width:100%;border-collapse:collapse;font-size:9pt;background:#fff;">
      <thead>
        <tr style="background:#e6e6e6;">
          <th style="border:1px solid #999;padding:4px;width:25%;">Tipo</th>
          <th style="border:1px solid #999;padding:4px;">Descripción</th>
          <th style="border:1px solid #999;padding:4px;width:60px;text-align:center;">Básico</th>
          <th style="border:1px solid #999;padding:4px;width:80px;text-align:center;">Intermedio</th>
          <th style="border:1px solid #999;padding:4px;width:80px;text-align:center;">Avanzado</th>
        </tr>
      </thead>
      <tbody>
  `;

          // Agrupar por tipo
          const grouped = {};

          profileData.TechnicalSkills.forEach((skill) => {
            const type = (skill.TypeProfileText || "OTROS").trim();

            if (!grouped[type]) {
              grouped[type] = [];
            }

            grouped[type].push(skill);
          });

          // Renderizar grupos
          Object.keys(grouped).forEach((type) => {
            const skills = grouped[type];
            const rowspan = skills.length;

            skills.forEach((skill, index) => {
              const desc = (skill.PprDescription || "").trim();

              const basic = skill.Basic ? "P" : "";
              const intermediate = skill.Intermediate ? "P" : "";
              const advanced = skill.Advanced ? "P" : "";

              html += `<tr>`;

              // Solo en la primera fila del grupo
              if (index === 0) {
                html += `
          <td rowspan="${rowspan}" 
              style="border:1px solid #999;padding:4px;font-weight:600;vertical-align:middle;">
            ${type}
          </td>
        `;
              }

              html += `
        <td style="border:1px solid #999;padding:4px;">
          ${desc}
        </td>

        <td style="border:1px solid #999;text-align:center;">
          ${basic}
        </td>

        <td style="border:1px solid #999;text-align:center;">
          ${intermediate}
        </td>

        <td style="border:1px solid #999;text-align:center;">
          ${advanced}
        </td>
      `;

              html += `</tr>`;
            });
          });

          html += `
      </tbody>
    </table>
  </div>
  `;
        }
      }
      // Sección: Competencias
      if (profileData.Tools && profileData.Tools.length > 0) {
        const dynamicCompetencyLevels = Array.isArray(
          profileData.CompetencyLevels,
        )
          ? profileData.CompetencyLevels
          : [];

        if (dynamicCompetencyLevels.length > 0) {
          html += `
  <div>
    <strong style="font-size:10pt;">Competencias</strong>

    <table style="width:100%;border-collapse:collapse;font-size:9pt;background:#fff;">
      <thead>
        <tr style="background:#e6e6e6;">
          <th style="border:1px solid #999;padding:4px;width:25%;">Tipo</th>
          <th style="border:1px solid #999;padding:4px;">Competencia</th>
  `;

          dynamicCompetencyLevels.forEach((level) => {
            html += `<th style="border:1px solid #999;padding:4px;width:40px;text-align:center;">${level}</th>`;
          });

          html += `
        </tr>
      </thead>
      <tbody>
  `;

          const grouped = {};
          profileData.Tools.forEach((c) => {
            const type = (c.TypeProfileText || "OTROS").trim();
            if (!grouped[type]) grouped[type] = [];
            grouped[type].push(c);
          });

          Object.keys(grouped).forEach((type) => {
            const items = grouped[type];
            const rowspan = items.length;

            items.forEach((c, index) => {
              const desc = (c.PprDescription || "").trim();
              html += `<tr>`;

              if (index === 0) {
                html += `
        <td rowspan="${rowspan}" style="border:1px solid #999;padding:4px;font-weight:600;vertical-align:middle;">
          ${type}
        </td>
        `;
              }

              html += `<td style="border:1px solid #999;padding:4px;">${desc}</td>`;

              dynamicCompetencyLevels.forEach((level) => {
                const mark = c.LevelLabel === level ? "P" : "";
                html += `<td style="border:1px solid #999;text-align:center;">${mark}</td>`;
              });

              html += `</tr>`;
            });
          });

          html += `
      </tbody>
    </table>
  </div>
  `;
        } else {
          html += `
  <div>
    <strong style="font-size:10pt;">Competencias</strong>

    <table style="width:100%;border-collapse:collapse;font-size:9pt;background:#fff;">
      <thead>
        <tr style="background:#e6e6e6;">
          <th style="border:1px solid #999;padding:4px;width:25%;">Tipo</th>
          <th style="border:1px solid #999;padding:4px;">Competencia</th>
          <th style="border:1px solid #999;padding:4px;width:40px;text-align:center;">1</th>
          <th style="border:1px solid #999;padding:4px;width:40px;text-align:center;">2</th>
          <th style="border:1px solid #999;padding:4px;width:40px;text-align:center;">3</th>
          <th style="border:1px solid #999;padding:4px;width:40px;text-align:center;">4</th>
        </tr>
      </thead>
      <tbody>
  `;

          const grouped = {};

          profileData.Tools.forEach((c) => {
            const type = (c.TypeProfileText || "OTROS").trim();

            if (!grouped[type]) {
              grouped[type] = [];
            }

            grouped[type].push(c);
          });

          Object.keys(grouped).forEach((type) => {
            const items = grouped[type];
            const rowspan = items.length;

            items.forEach((c, index) => {
              const desc = (c.PprDescription || "").trim();

              const v1 = c.Value1 ? "P" : "";
              const v2 = c.Value2 ? "P" : "";
              const v3 = c.Value3 ? "P" : "";
              const v4 = c.Value4 ? "P" : "";

              html += `<tr>`;

              if (index === 0) {
                html += `
        <td rowspan="${rowspan}"
            style="border:1px solid #999;padding:4px;font-weight:600;vertical-align:middle;">
          ${type}
        </td>
        `;
              }

              html += `
        <td style="border:1px solid #999;padding:4px;">
          ${desc}
        </td>

        <td style="border:1px solid #999;text-align:center;">${v1}</td>
        <td style="border:1px solid #999;text-align:center;">${v2}</td>
        <td style="border:1px solid #999;text-align:center;">${v3}</td>
        <td style="border:1px solid #999;text-align:center;">${v4}</td>
      `;

              html += `</tr>`;
            });
          });

          html += `
      </tbody>
    </table>
  </div>
  `;
        }
      }

      // Sección: Experiencia
      if (hasExperience) {
        html += `
          <div>
            <strong style="font-size:10pt;">Experiencia</strong>

            <table style="width:100%;border-collapse:collapse;font-size:9pt;background:#fff;">
              <thead>
                <tr style="background:#e6e6e6;">
                  <th style="border:1px solid #999;padding:4px;">Detalle de la experiencia</th>
                  <th style="border:1px solid #999;padding:4px;width:150px;text-align:center;">
                    Tiempo en años
                  </th>
                </tr>
              </thead>
              <tbody>
          `;

        profileData.Experience.forEach((exp) => {
          const desc = (exp.PprDescription || "").trim();
          const time = (exp.TimeDescription || "").trim();

          html += `
            <tr>
              <td style="border:1px solid #999;padding:4px;">
                ${desc}
              </td>

              <td style="border:1px solid #999;text-align:center;">
                ${time}
              </td>
            </tr>
          `;
        });

        html += `
          </tbody>
        </table>
      </div>
      `;
      }

      html += "</div>";
      return html;
    },
  },
  created() {
    this.loadRequirement();
    this.loadApprovals();
  },
};
</script>

<style scoped>
.formato-container {
  background-color: #fff;
  padding: 8px;
}

.formato-requerimiento {
  font-family: Arial, sans-serif;
  font-size: 9pt;
  position: relative;
}

.page {
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  background: white;
  position: relative;
  page-break-after: always;
  break-after: page;
}

.header-table,
.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 2px;
}

.header-table td,
.data-table td {
  border: 1px solid black;
  padding: 6px;
  vertical-align: top;
  font-size: 9pt;
}

.title {
  font-size: 12pt;
  font-weight: bold;
  text-align: center;
  margin: 2px 0;
  line-height: 1.2;
}

@media print {
  .formato-container {
    background-color: #fff;
    padding: 0;
  }

  .page {
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 10px;
    width: 100%;
    page-break-after: always;
    break-after: page;
  }

  .page:last-of-type {
    page-break-after: auto;
    break-after: auto;
  }
}
</style>
